import React from 'react';
import { Badge, Card, Group, Text, Title } from '@mantine/core';

// Placeholder card for a panel whose prerequisite (usually a generated Design Model) doesn't exist yet.
export default function PanelStub({ title, step, blurb }) {
  return (
    <Card withBorder padding="lg" radius="md">
      <Group justify="space-between" mb="xs">
        <Title order={4}>{title}</Title>
        <Badge variant="light" color="gray">{step}</Badge>
      </Group>
      <Text c="dimmed" size="sm">{blurb}</Text>
    </Card>
  );
}
